
import { defineComponent } from 'vue'
import SessionService from '../common/sessionService'

export default defineComponent({
  name: 'Login',

  beforeRouteEnter (to, from, next) {
    next()
  },

  mounted () {
    const authCode = this.$route.query.code

    if (authCode) {
      this.$axios.post('authentication', { code: authCode }).then(() => {
        SessionService.initializeSession().then(() => {
          setTimeout(() => {
            const path = sessionStorage.getItem('reload_path')
            sessionStorage.removeItem('reload_path')
            if (path && path !== '') {
              this.$router.push(path)
            } else {
              this.$router.push('/')
            }
          }, 600)
        })
      }).catch(res => {
        console.log(res)
      })
    }
  }
})
